var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiArrowPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.744 9.1l4.694-4.827L7.2 3 .395 10 7.2 17l1.238-1.273L3.744 10.9h19.15V9.1z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--arrow-prev-14e7f1a441fc4bc9e8942627590ec4a5.svg";
export { SvgIconUiArrowPrev as Component };